<dialog
  #dialog
  qai-dialog
  [description]="''"
  [heading]="'Save as product default'"
  (afterClose)="handleClose()"
  (closeButtonClicked)="handleCloseButtonClick()"
>
  <div class="content">
    <span>
      This will overwrite the default {{ keywordTitle }} for the product
      {{ moduleName }}.
    </span>
    <span>
      These words will be added to new simulations for {{ moduleName }}. All
      calls for the product {{ moduleName }} will be effected.
    </span>
  </div>

  <div class="modal-actions">
    <button
      qai-button
      kind="secondary"
      size="medium"
      [disabled]="networkRequestInProgress"
      (click)="handleClose()"
    >
      Cancel
    </button>
    <button
      qai-button
      kind="destructive"
      size="medium"
      [disabled]="networkRequestInProgress"
      (click)="handleConfirm()"
    >
      Confirm
    </button>
  </div>
</dialog>
